import { RxAvatar } from "react-icons/rx";
import { IoBagCheckOutline } from "react-icons/io5";
import { CiMail } from "react-icons/ci";

const OrderSide = ({ user }) => {
	return (
		<div className="w-full text-sm font-medium space-y-4">
			<div className="space-y-3 bg-white p-4 md:p-5 rounded-2xl border-none">
				<h5 className="font-bold text-gray-900 md:text-lg text-base border-b border-gray-100 pb-2">Customer</h5>
				<div className="space-y-3 text-sm text-gray-600">
					<div className="flex items-center gap-x-3">
						<RxAvatar className="text-gray-400 text-xl" />
						<h6 className="font-semibold text-gray-800">{user?.full_name}</h6>
					</div>

					<div className="flex items-center gap-x-3">
						<IoBagCheckOutline className="text-gray-400 text-xl" />
						<h6>{"1"} Order</h6>
					</div>

					<p className="text-xs text-gray-400">Customer is tax-exempt</p>
				</div>
			</div>

			<div className="space-y-3 bg-white p-4 md:p-5 rounded-2xl border-none">
				<h5 className="font-bold text-gray-900 md:text-lg text-base border-b border-gray-100 pb-2">Contact Information</h5>
				<div className="space-y-3 text-sm text-gray-600">
					<div className="flex items-center gap-x-3">
						<CiMail className="text-gray-400 text-xl" />
						<h6 className="w-5/6 truncate">{user?.email}</h6>
					</div>

					<div className="flex items-center gap-x-3">
						<h6 className="font-bold text-gray-500">Phone:</h6>
						<h6>{user?.phone_number}</h6>
					</div>
				</div>
			</div>

			<div className="space-y-3 bg-white p-4 md:p-5 rounded-2xl border-none">
				<h5 className="font-bold text-gray-900 md:text-lg text-base border-b border-gray-100 pb-2">Shipping Address</h5>
				<div className="space-y-2 text-sm text-gray-600">
					<div className="flex items-center gap-x-3">
						<RxAvatar className="text-gray-400 text-xl" />
						<h6 className="w-5/6 truncate font-semibold text-gray-800">{user?.full_name}</h6>
					</div>

					<div className="text-sm pl-8">
						<p className="w-full text-gray-500 leading-relaxed">{user?.billing_address}</p>
					</div>
				</div>
			</div>

			<div className="space-y-3 bg-white p-4 md:p-5 rounded-2xl border-none">
				<h5 className="font-bold text-gray-900 md:text-lg text-base border-b border-gray-100 pb-2">Billing Address</h5>
				<p className="text-gray-500 text-sm">Same as shipping address</p>
			</div>
		</div>
	);
};

export default OrderSide;
